import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getDataWithMockFallback } from '@shared/utils/http.util';
import { Alert } from '@app/shared/types/ui';
import { EnvironmentService } from '@app/core/services/environment.service';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private readonly http = inject(HttpClient);
  private readonly environmentService = inject(EnvironmentService);
  private readonly baseUrl = `${this.environmentService.apiBaseUrl}/User`;

  getAlerts(): Observable<Alert[]> {
    const realCall = this.http.get<Alert[]>(`${this.baseUrl}/Alerts`);
    return getDataWithMockFallback([], realCall, this.environmentService);
  }
}
